window.addEventListener('scroll', throttle(callback, 50));

function throttle(fn, wait) {
    var time = Date.now();
    return function() {
        if ((time + wait - Date.now()) < 0) {
            fn();
            time = Date.now();
        }
    }
}

function callback() {
    if (jQuery(this).scrollTop() >= 70) {
        jQuery('.alert-zone').addClass('ioc-alert-fixed');
        jQuery('sec-body').addClass('has-alert-fixed');
    }
    else {
        jQuery('.alert-zone').removeClass('ioc-alert-fixed');
        jQuery('sec-body').removeClass('has-alert-fixed');
    }
}